export { default as QuickBookingArticleC } from './QuickBookingArticleC'
export { default as QuickBookingArticleCSkeleton } from './Skeleton'
